import React from 'react';
import { Badge, Card, CardHeader } from '@opendate-app/setlist';

export function ComingSoonBadge() {
  return <Badge color="gray" size="sm">Coming soon</Badge>;
}

function ComingSoonCard({ title, supportingText, rows = 4 }) {
  return (
    <Card header={<CardHeader title={title} supportingText={supportingText} actions={<ComingSoonBadge />} />}>
      <div aria-hidden="true">
        {Array.from({ length: rows }, (_, i) => (
          <div
            key={i}
            style={{
              height: 12,
              width: `${92 - i * 14}%`,
              borderRadius: 6,
              marginBottom: 14,
              background: 'var(--sl-bg-secondary)',
            }}
          />
        ))}
      </div>
    </Card>
  );
}

export default ComingSoonCard;
